import { BenefitType } from '@/types/benefits/benefitTypes';

const RECEIVER = '/receivers';
const DISTRIBUTOR = '/distributors';
const ADMIN = '/admin';

const SUPPLIERS = `${RECEIVER}/fournisseurs`;
const BENEFITS = `${RECEIVER}/prestations`;
const CIRCUITS = `${RECEIVER}/circuits`;
const DISTRIBUTORS = `${RECEIVER}/distributors`;
const TRASH = `${RECEIVER}/corbeille`;

export const PATHS = {
  profile: '/profile',
  home: {
    dashboard: `${RECEIVER}/dashboard`,
    suppliers: {
      list: SUPPLIERS,
      create: `${SUPPLIERS}/create`,
      view: `${SUPPLIERS}/:supplierId`,
    },
    benefits: {
      list: BENEFITS,
      activity: {
        create: `${BENEFITS}/activity/create`,
        view: `${BENEFITS}/activity/:benefitId`,
      },
      meal: {
        create: `${BENEFITS}/meal/create`,
        view: `${BENEFITS}/activity/:benefitId`,
      },
      transfer: {
        create: `${BENEFITS}/transfer/create`,
        view: `${BENEFITS}/activity/:benefitId`,
      },
      vehicleWithChauffeur: {
        create: `${BENEFITS}/vehicle-with-chauffeur/create`,
        view: `${BENEFITS}/vehicle-with-chauffeur/:benefitId`,
      },
      carRental: {
        create: `${BENEFITS}/car-rental/create`,
        view: `${BENEFITS}/car-rental/:benefitId`,
      },
      flight: {
        create: `${BENEFITS}/flight/create`,
        view: `${BENEFITS}/flight/:benefitId`,
      },
      hotel: {
        create: `${BENEFITS}/hotel/create`,
        view: `${BENEFITS}/hotel/:benefitId`,
      },
    },
    circuits: {
      list: CIRCUITS,
      create: `${CIRCUITS}/create`,
      view: `${CIRCUITS}/:circuitId`,
    },
    distributors: {
      list: DISTRIBUTORS,
      add: `${DISTRIBUTORS}/add`,
    },
    trash: TRASH,
    reservations: {
      requests: {
        list: `${RECEIVER}/reservations/requests`,
        view: `${RECEIVER}/reservations/requests/:estimateId`,
      },
    },
    stats: {
      list: `${RECEIVER}/stats`,
    },
  },
  distributors: {
    dashboard: `${DISTRIBUTOR}/dashboard`,
    circuits: {
      list: `${DISTRIBUTOR}/circuits`,
      details: `${DISTRIBUTOR}/circuits/:circuitId`,
      editableDetails: `${DISTRIBUTOR}/circuits/editable/:editableCircuitId`,
    },
    estimates: {
      list: `${DISTRIBUTOR}/estimates`,
      view: `${DISTRIBUTOR}/estimates/:projectId/:estimateId`,
    },
    receivers: {
      list: `${DISTRIBUTOR}/receivers`,
    },
    clients: {
      list: `${DISTRIBUTOR}/clients`,
      create: `${DISTRIBUTOR}/clients/create`,
      view: `${DISTRIBUTOR}/clients/:clientId`,
      estimates: {
        list: `${DISTRIBUTOR}/clients/:clientId/projects/:projectId/estimates`,
        view: `${DISTRIBUTOR}/clients/:clientId/projects/:projectId/estimates/:estimateId`,
      },
    },
    stats: {
      list: `${DISTRIBUTOR}/stats`,
    },
  },
  admin: {
    dashboard: `${ADMIN}/dashboard`,
    stats: `${ADMIN}/stats`,
    receivers: `${ADMIN}/receivers`,
    distributors: `${ADMIN}/distributors`,
  },
  auth: {
    login: '/login',
    register: '/register',
    selectProfile: '/select-profile',
  },
  protected: {
    estimate: '/estimates/:projectId/:estimateId',
  },
};

export const BENEFIT_TO_PATH = {
  [BenefitType.ACTIVITY]: PATHS.home.benefits.activity,
  [BenefitType.MEAL]: PATHS.home.benefits.meal,
  [BenefitType.TRANSFER]: PATHS.home.benefits.transfer,
  [BenefitType.VEHICLE_WITH_CHAUFFEUR]:
    PATHS.home.benefits.vehicleWithChauffeur,
  [BenefitType.VEHICLE]: PATHS.home.benefits.carRental,
  [BenefitType.VOL]: PATHS.home.benefits.flight,
  [BenefitType.HOTEL]: PATHS.home.benefits.hotel,
};
